module.exports = __webpack_public_path__ + "static/media/how-a-transfarmation-can-help-the-climate.5740a26e.jpg";